// Agrega comas de separación en los números
export const commas = (value: string | number): string | number => {
  try {
    return value.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ',');
  }
  catch {
    return value;
  }
};
